module.exports = __webpack_public_path__ + "static/media/assa-pin.18e349df.svg";